import { PopUpProps, FormData } from '../../types/types';
import Button from '../../components/Button/Button';
import React, { useState, ChangeEvent } from 'react';
import Choice from './Choice/Choice';
import { choiceItems } from '../../data/data';
import ProhFile from '../../assets/files/Privacy_and_Cookies_Policy_Contact_Pay.pdf';
const PopUp: React.FC<PopUpProps> = ({
  className,
  onSubmit,
  setIsOpen,
  setIsRequestSent,
}) => {
  const [formData, setFormData] = useState<FormData>({
    nameUser: '',
    connection: '',
    connectionItem: '',
    message: '',
    privacyPolicy: true,
  });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isChoiceSelected, setIsChoiceSelected] = useState(false);

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value, type } = e.target;

    let fieldValue: string | boolean = value;

    if (type === 'checkbox') {
      fieldValue = (e.target as HTMLInputElement).checked;
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: fieldValue,
    }));
  };
  const handleChoiceSelect = () => {
    setIsChoiceSelected(true);
  };
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsFormSubmitted(true);
    if (!validateFormData()) {
      return;
    }
    onSubmit(formData);
    setIsOpen(false);
    setIsRequestSent(true);
    try {
      const response = await fetch('http://localhost:5000/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        console.log('Email sent successfully!');
      } else {
        console.log('Message sending failed');
      }
    } catch (error) {
      console.log('Request failed', error);
    }
  };
  const validateFormData = () => {
    const isValidConnectionItem = validateConnectionItem(
      formData.connectionItem
    );
    const isValidPrivacyPolicy = formData.privacyPolicy;

    return isValidConnectionItem && isValidPrivacyPolicy;
  };

  const validateConnectionItem = (input: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneNumberRegex = /^\+?\d+$/;
    const atSignRegex = /@/;

    return (
      emailRegex.test(input) ||
      phoneNumberRegex.test(input) ||
      atSignRegex.test(input)
    );
  };
  return (
    <>
      <form onSubmit={handleSubmit} className={className}>
        <div className={`${className}__item `}>
          <label className='text-large'>
            Choice preferable communication channel
          </label>
          <Choice
            className='choice'
            social={choiceItems}
            formData={formData}
            handleChange={handleChange}
            handleChoiceSelect={handleChoiceSelect}
          />
        </div>
        {isChoiceSelected && (
          <>
            <div className={`${className}__item info`}>
              <label className='text-large'>
                Fill in your contact information
              </label>
              <input
                className={`${className}__input ${
                  isFormSubmitted &&
                  !validateConnectionItem(formData.connectionItem)
                    ? 'error'
                    : ''
                }`}
                type='text'
                name='connectionItem'
                value={formData.connectionItem}
                placeholder={formData.connection}
                onChange={handleChange}
              />
              <input
                className={`${className}__input `}
                type='text'
                name='nameUser'
                value={formData.nameUser}
                placeholder='How can I call you?'
                onChange={handleChange}
              />
            </div>
            <div className={`${className}__item`}>
              <textarea
                className={`${className}__textarea`}
                name='message'
                value={formData.message}
                onChange={handleChange}
                placeholder='Any extra information for us to be prepared for an initial talk?'
              />
            </div>
            <div className={`${className}__item checkbox`}>
              <input
                id='checkbox'
                className={`checkbox__input ${
                  isFormSubmitted && !formData.privacyPolicy ? 'error' : ''
                }`}
                type='checkbox'
                name='privacyPolicy'
                checked={formData.privacyPolicy}
                onChange={handleChange}
              />
              <label className={`checkbox__label `} htmlFor='checkbox'>
                <span className='checkbox__text text-normal'>
                  I have read and acknowledged the
                  <a
                    href={ProhFile}
                    rel='noopener noreferrer'
                    className={`${className}__link`}
                    target='_blank'
                  >
                    &nbsp;Privacy Policy.
                  </a>
                </span>
              </label>
            </div>
            <div className='g-recaptcha' data-sitekey=''></div>
            <Button type='submit' className='form__button'>
              Send
            </Button>
          </>
        )}
      </form>
    </>
  );
};

export default PopUp;
